import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css';

import Header from "./components/Header";
import AppNavbar from "./components/AppNavbar";
import Footer from "./components/Footer";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ResetPassword from "./pages/ResetPassword";

import User_Dashboard from "./components/User_Dashboard_Test";

import AddUser from "./pages/AddUser";
import UserList from "./pages/UserList";
import UserEdit from "./pages/UserEdit";

import Add_data_entry from "./pages/Add_data_entry";
import List_data_entry from "./pages/List_data_entry";
import Edit_data_entry from "./pages/Edit_data_entry";
import Upload_details from "./pages/Upload_document";

import MolecularProfile from "./pages/Molecular/MolecularProfile";
import ClinicalProfile from "./pages/Clinical/ClinicalProfile";
import PIWILmRNA from "./pages/Molecular/PIWILmRNA";
import PIWILProteinExpression from "./pages/Molecular/PIWILProteinExpression";
import DFIDataSCDKit from "./pages/Molecular/DFIDataSCDKit";
import CometAssay from "./pages/Molecular/CometAssay";
import OxidativeStressData from "./pages/Molecular/OxidativeStressData";
import YMicroDeletion from "./pages/Molecular/YMicroDeletion";

import ClinicalData from "./pages/Clinical/ClinicalData";
import FollowUpData from "./pages/Clinical/FollowUpData";
import IUI from "./pages/Clinical/IUI";
import After14Days from "./pages/Clinical/After14Days";
import Th11To13thWeek from "./pages/Clinical/Th11To13thWeek";
import Th18to20Weeks from "./pages/Clinical/Th18-20Weeks";
import Weeks24 from "./pages/Clinical/Weeks24";
import IVF from "./pages/Clinical/IVF";
import ICSI from "./pages/Clinical/ICSI";
import FertilizationRate from "./pages/Clinical/Fertilization_rate";

import Literature_Avenue from "./pages/Literature_Avenue";
import Literature_Avenue_List from "./pages/Literature_Avenue_List";
import Literature_Avenue_Edit from "./pages/Literature_Avenue_Edit";

import Literature_Master from "./pages/Literature_Master";
import Literature_Master_List from "./pages/Literature_Master_List";
import Literature_Master_Edit from "./pages/Literature_Master_Edit";

import Patient_report_sample_id_wise from "./pages/Patient_report_sample_id_wise";

import Male_Details from "./pages/Male_Details";
import Update_Male_Details from "./pages/Update_Male_Details";
import Female_details from "./pages/Female_Details";
import Center_list from "./pages/Center_list";



import Analytics from "./pages/Analytics";

import Enquiry from "./pages/report/Enquiry";
import LogList from "./pages/report/LogList";
import Literature_report from "./pages/report/Literature_report";
import Molecular_report from "./pages/report/Molecular_report";
import Clinical_report from "./pages/report/Clinical_report";

import All_Report_download from "./pages/report/print/All_Report_download";

import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./context/AuthContext";

function App() {
  const { token, user } = useAuth();
  const isLoggedIn = !!token;


  const location = useLocation();
  const noHeaderFooterPaths = ["/All_Report_download"];
  const hideHeaderFooter = noHeaderFooterPaths.some(path =>
    location.pathname.startsWith(path)
  );

  const AdminOnly = ({ children }) => {
    const { user } = useAuth();

    if (user?.role != 1) {
      return <Navigate to="/dashboard" />;
    }

    return children;
  };

  return (
    <div className="d-flex flex-column min-vh-100">

      {isLoggedIn && !hideHeaderFooter && <Header />}
      {isLoggedIn && !hideHeaderFooter && <AppNavbar />}

      <main className={isLoggedIn ? "flex-fill container my-4" : "flex-fill"}>

        <Routes>

          {/* <Route path="/" element={<Login />} /> */}
          <Route
            path="/"
            element={isLoggedIn ? <Navigate to="/dashboard" /> : <Login />}
          />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          <Route
            path="/dashboard"
            element={isLoggedIn ? <Dashboard /> : <Navigate to="/" replace />}
          />

          {/* <Route path="/register" element={isLoggedIn ? <AddUser /> : <Navigate to="/" />} />
          <Route path="/UserList" element={isLoggedIn ? <UserList /> : <Navigate to="/" />} />
          <Route path="/UserEdit/:id" element={isLoggedIn ? <UserEdit /> : <Navigate to="/" />} /> */}

          <Route
            path="/register"
            element={
              isLoggedIn ? (
                <AdminOnly>
                  <AddUser />
                </AdminOnly>
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/UserList"
            element={
              isLoggedIn ? (
                <AdminOnly>
                  <UserList />
                </AdminOnly>
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/UserEdit/:id"
            element={
              isLoggedIn ? (
                <AdminOnly>
                  <UserEdit />
                </AdminOnly>
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route path="/data-entry" element={isLoggedIn ? <Add_data_entry /> : <Navigate to="/" />} />
          <Route path="/List_data_entry" element={isLoggedIn ? <List_data_entry /> : <Navigate to="/" />} />
          <Route path="/Edit_data_entry/:id" element={isLoggedIn ? <Edit_data_entry /> : <Navigate to="/" />} />

          <Route path="/Upload_details" element={isLoggedIn ? <Upload_details /> : <Navigate to="/" />} />

          {/* Molecular */}
          <Route path="/molecular-profile/:sample_id" element={isLoggedIn ? <MolecularProfile /> : <Navigate to="/" />} />
          <Route path="/piwil-mrna" element={isLoggedIn ? <PIWILmRNA /> : <Navigate to="/" />} />
          <Route path="/piwil-protein-expression" element={isLoggedIn ? <PIWILProteinExpression /> : <Navigate to="/" />} />
          <Route path="/DFI-data-SCD-kit" element={isLoggedIn ? <DFIDataSCDKit /> : <Navigate to="/" />} />
          <Route path="/Comet-Assay" element={isLoggedIn ? <CometAssay /> : <Navigate to="/" />} />
          <Route path="/Oxidative-stress-data" element={isLoggedIn ? <OxidativeStressData /> : <Navigate to="/" />} />
          <Route path="/y-microdeletion" element={isLoggedIn ? <YMicroDeletion /> : <Navigate to="/" />} />

          {/* Clinical */}
          <Route path="/clinical-profile/:sample_id" element={isLoggedIn ? <ClinicalProfile /> : <Navigate to="/" />} />
          <Route path="/Clinical-Data" element={isLoggedIn ? <ClinicalData /> : <Navigate to="/" />} />
          <Route path="/Follow-Up-Data/:sample_id" element={isLoggedIn ? <FollowUpData /> : <Navigate to="/" />} />
          <Route path="/IUI/:sample_id" element={isLoggedIn ? <IUI /> : <Navigate to="/" />} />
          <Route path="/After14Days" element={isLoggedIn ? <After14Days /> : <Navigate to="/" />} />
          <Route path="/Th11To13thWeek" element={isLoggedIn ? <Th11To13thWeek /> : <Navigate to="/" />} />
          <Route path="/Th18to20Weeks" element={isLoggedIn ? <Th18to20Weeks /> : <Navigate to="/" />} />
          <Route path="/Weeks24" element={isLoggedIn ? <Weeks24 /> : <Navigate to="/" />} />
          <Route path="/IVF/:sample_id" element={isLoggedIn ? <IVF /> : <Navigate to="/" />} />
          <Route path="/ICSI/:sample_id" element={isLoggedIn ? <ICSI /> : <Navigate to="/" />} />
          <Route path="/fertilization_rate" element={isLoggedIn ? <FertilizationRate /> : <Navigate to="/" />} />

          <Route path="/Literature_Avenue" element={isLoggedIn ? <Literature_Avenue /> : <Navigate to="/" />} />
          <Route path="/Literature_Avenue_List" element={isLoggedIn ? <Literature_Avenue_List /> : <Navigate to="/" />} />
          <Route path="/Literature_Avenue_Edit/:master_id" element={isLoggedIn ? <Literature_Avenue_Edit /> : <Navigate to="/" />} />

          <Route path="/Literature_Master" element={isLoggedIn ? <Literature_Master /> : <Navigate to="/" />} />
          <Route path="/Literature_Master_List" element={isLoggedIn ? <Literature_Master_List /> : <Navigate to="/" />} />
          <Route path="/Literature_Master_Edit/:master_id" element={isLoggedIn ? <Literature_Master_Edit /> : <Navigate to="/" />} />

          <Route path="/Male_Details" element={isLoggedIn ? <Male_Details /> : <Navigate to="/" />} />
          <Route path="/Update_Male_Details/:male_id" element={isLoggedIn ? <Update_Male_Details /> : <Navigate to="/" />} />
          <Route path="/female_details" element={isLoggedIn ? <Female_details /> : <Navigate to="/" />} />
          <Route path="/Center_list" element={isLoggedIn ? <Center_list /> : <Navigate to="/" />} />
          <Route path="/Patient_report_sample_id_wise/:maleID" element={isLoggedIn ? <Patient_report_sample_id_wise /> : <Navigate to="/" />} />

          <Route path="/user-dashboard" element={isLoggedIn ? <User_Dashboard /> : <Navigate to="/" />} />


          <Route path="/Analytics" element={isLoggedIn ? <Analytics /> : <Navigate to="/" />} />

          {/* Reports routes////////////////// */}
          <Route path="/logs" element={isLoggedIn ? <LogList /> : <Navigate to="/" />} />
          <Route path="/enquiry" element={isLoggedIn ? <Enquiry /> : <Navigate to="/" />} />
          <Route path="/literature_report" element={isLoggedIn ? <Literature_report /> : <Navigate to="/" />} />
          <Route path="/molecular_report" element={isLoggedIn ? <Molecular_report /> : <Navigate to="/" />} />

          <Route path="/clinical_report" element={isLoggedIn ? <Clinical_report /> : <Navigate to="/" />} />


          {/* ///////////////////////////print///////////// */}


          <Route path="/All_Report_download/:male_id" element={isLoggedIn ? <All_Report_download /> : <Navigate to="/" />} />


          {/* 🔐 FALLBACK */}
          <Route path="*" element={<Navigate to="/" />} />

        </Routes>

      </main>

      {isLoggedIn && !hideHeaderFooter && <Footer />}
    </div>
  );
}

export default App;
